import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

export default function TestimonialsSection({ t }) {
    return (
        <section id="referencie" className="border-t border-white/5 px-5 sm:px-8 py-24 sm:py-28">
            <div className="mx-auto max-w-6xl">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.7, ease: EASE }}
                    className="mb-14"
                >
                    <p className="flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.3em] text-glacier">
                        <span className="inline-block h-px w-10 bg-glacier/60" />
                        {t.testimonials.overline}
                    </p>
                    <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight">
                        {t.testimonials.title}
                    </h2>
                </motion.div>

                <div data-testid="testimonials-grid" className="grid gap-6 md:grid-cols-3">
                    {t.testimonials.items.map((item, i) => (
                        <motion.figure
                            key={item.author}
                            data-testid={`testimonial-card-${i}`}
                            initial={{ opacity: 0, y: 28 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.7, delay: i * 0.1, ease: EASE }}
                            className="flex flex-col rounded-lg border border-white/10 bg-coal p-7 transition-[border-color] duration-500 hover:border-glacier/40"
                        >
                            <Quote size={22} className="text-glacier/70" fill="currentColor" strokeWidth={0} />
                            <blockquote className="mt-5 flex-1 text-[15px] leading-relaxed text-ivory/90">
                                {item.quote}
                            </blockquote>
                            <figcaption className="mt-6 border-t border-white/5 pt-5">
                                <div className="font-display text-base font-medium text-ivory">{item.author}</div>
                                <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-fog">
                                    {item.role}
                                </div>
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
